import React from 'react'
import { type GroupSummary } from '@fs/zion-tree-types'
import { type GedcomFile } from '../../../services/groupTypes'
import CetActions, { CetActionsSkeleton } from '../upload-page/upload-row/CetActions'
import UploadProgressBar from '../../../components/UploadProgressBar'

type Props = {
  file?: GedcomFile
  group?: GroupSummary
  isProcessingOrLoading: boolean
  isPrivateTree?: boolean
  isMobile: boolean
}

export default function ManageTreeRowActions({
  file,
  group,
  isProcessingOrLoading,
  isPrivateTree,
  isMobile,
}: Props): JSX.Element {
  if (file?.fileStatus === 'IMPORTING' && file.percentComplete != null) {
    return <UploadProgressBar percentComplete={file.percentComplete} />
  }

  const groupId = group?.id
  const treeId = group?.treeIds?.[0]
  const isResearcherTree = group?.types?.includes('RESEARCHER_TREE') ?? false
  const fileStatus = file?.fileStatus

  return (
    <CetActions
      groupId={groupId}
      isManageTree
      treeId={treeId}
      fileStatus={fileStatus}
      isProcessingOrLoading={isProcessingOrLoading}
      isPrivateTree={isPrivateTree}
      isResearcherTree={isResearcherTree}
      isMobile={isMobile}
    />
  )
}

export function ManageTreeRowActionsSkeleton({ isMobile }: { isMobile?: boolean }): JSX.Element {
  return <CetActionsSkeleton isMobile={isMobile} />
}
